import { MutationKeyConfig, QueryKeyConfig } from '../api-helper';

export const servicesApiKeyStore = {
  createService: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_SERVICES`],
    route: `/Service`,
    action: 'POST',
  }),
  updateService: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_SERVICES`],
    route: `/Service`,
    action: 'PUT',
  }),
  deleteService: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SERVICE`],
    route: `/Service/${id}`,
    action: 'DELETE',
  }),
  getServices: (): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES`],
    route: `/Service`,
  }),
  getService: (id: number): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_BY_ID`, id],
    route: `/Service/${id}`,
    isEnabled: !!id && id >= 0,
  }),
  getServiceCustomerMappings: (customerID: number): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES_CUSTOMER_MAPPING`, customerID],
    route: `/Service/Mappings?CustomerID=${customerID}`,
    isEnabled: !!customerID && customerID >= 0,
  }),
  getServiceOfficeMappings: (officeID: any): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES_OFFICE_MAPPING`, officeID],
    route: `/Service/Mappings?OfficeID=${officeID}`,
    isEnabled: !!officeID && officeID >= 0,
  }),
  getServiceProjectMappings: (projectID: any): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES_PROJECT_MAPPING`, projectID],
    route: `/Service/Mappings?ProjectID=${projectID}`,
    isEnabled: !!projectID && projectID >= 0,
  }),
  getServiceUnitMappings: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES_UNIT_MAPPING`, unitID],
    route: `/Service/Mappings?UnitID=${unitID}`,
    isEnabled: unitID >= 0,
  }),
  getRetestServices: (): QueryKeyConfig => ({
    queryKey: [`GET_RETEST_SERVICES`],
    route: `/Service/Retest`,
  }),
  getInitialServices: (): QueryKeyConfig => ({
    queryKey: [`GET_INITIAL_SERVICES`],
    route: `/Service/InitialServices`,
  }),
  getProjectContractedServices: (id: number): QueryKeyConfig => ({
    queryKey: [`GET_PROJECTCONTRACTED_SERVICES`, id],
    route: `/Service/ProjectContractedServices/WorkOrderID/${id}`,
  }),
  getServiceMunicipalityMappings: (municipalityID: any): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES_MUNICIPALITY_MAPPING`, municipalityID],
    route: `/Service/Mappings?MunicipalityID=${municipalityID}`,
    isEnabled: municipalityID >= 0,
  }),
  getServiceBillingTypes: (): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_BILLING_TYPES`],
    route: `/Service/BillingTypes`,
  }),
  getQBOAccounts: (): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_QBOAccounts`],
    route: `/Service/QBOAccounts`,
  }),
  createServiceType: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_SERVICE_TYPE`],
    route: `/Service/Type`,
    action: 'POST',
  }),
  updateServiceType: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_SERVICE_TYPE`],
    route: `/Service/Type`,
    action: 'PUT',
  }),
  deleteServiceType: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SERVICE_TYPE`, id],
    route: `/Service/Type/${id}`,
    action: 'DELETE',
  }),
  getServiceTypes: (): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_TYPES`],
    route: `/Service/Type`,
  }),
  updateWideCutoffTime: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_WIDE_CUT_OFF_TIME`],
    route: `/Service/MasterSettings`,
    action: 'PUT',
  }),
  getWideCutoffTime: (): QueryKeyConfig => ({
    queryKey: [`GET_WIDE_CUT_OFF_TIME`],
    route: `/Service/MasterSettings`,
  }),
  updateServiceSortOrder: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_SERVICE_SORT_ORDER`],
    route: `/Service/SortOrder`,
    action: 'PUT',
  }),

  getServiceMappingList: (
    customerID: any,
    officeID: any,
    projectID: any,
    unitID: any,
    municipalityID: any
  ): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES_MAPPING_LIST`, officeID, customerID, projectID, unitID, municipalityID],
    route: `/Service/MappingList?ProjectID=${!projectID ? 0 : projectID}&OfficeID=${!officeID ? 0 : officeID}&CustomerID=${!customerID ? 0 : customerID}&UnitID=${!unitID ? 0 : unitID}&MunicipalityID=${!municipalityID ? 0 : municipalityID}`,
    // isEnabled: !!officeID || !!customerID || !!projectID || !!unitID || !!municipalityID,
  }),
   getQBOServices: (): QueryKeyConfig => ({
      queryKey: [`GET_SERVICE_QBSERVICES`],
      route: `/Service/QBOServices`,
    }),
  /**
   * Update QuickBooks mapping for a service
   * @param payload { serviceID, qboServiceID, qboAccountID, qboClassID, reinspectionQboServiceID, reinspectionQboAccountID, reinspectionQboClassID }
   */
  updateQBOMapping: (): MutationKeyConfig => ({
    mutationKey: ['UPDATE_QBO_MAPPING'],
    route: '/Service/SetQBOMapping', 
    action: 'PUT',
  }),
  getOfficeServices: (officeID: number): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_PRICING_SERVICES`, officeID],
    route: `/Service/PricingListServices?officeID=${officeID}`,
    isEnabled: !!officeID && officeID >= 0,
  }),
  getProjectServices: (projectID: number): QueryKeyConfig => ({
    queryKey: [`GET_PROJECT_PRICING_SERVICES`, projectID],
    route: `/Service/PricingListServices?projectID=${projectID}`,
    isEnabled: !!projectID && projectID >= 0,
  }),
};
